var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ _vm.$attrs['class'], 'inline-button', { 'inline-button--no-border': !_vm.border }, { 'inline-button--slot': _vm.isSlot }],attrs:{"id":_vm.$attrs['id'],"title":_vm.title,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('icon',{attrs:{"icon":_vm.icon,"color":_vm.iconColor}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff88363a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/util/InputIconButton.vue
// module id = 7JOa
// module chunks = 0